export default "__VITE_ASSET__CCndjF52__"